/**
 * Support for showing error message when ajax request fails.
 * Needs initialization with container (which is inserted on first use) and message to show.
 */
Bingo.AjaxFailed = {};
Bingo.AjaxFailed.message = null;
Bingo.AjaxFailed.container = null;
Bingo.AjaxFailed.init = function (container, message) {
    Bingo.AjaxFailed.container = container;
    Bingo.AjaxFailed.message = message;
};

Bingo.AjaxFailed.showError = function (message) {
    if (Bingo.AjaxFailed.container !== null) {
        const container = $(Bingo.AjaxFailed.container);
        if (container.length) {
            const html = `<div class="M-alert alert -danger -close" data-role="alert"><div class="M-alert__description">${message}</div><button class="close M-alert__close" data-dismiss="alert"><img class="close" src="/src/images/basic/close.svg"></button></div>`;
            container.prepend(html);
        }
    }
};

/**
 * Integration of NProgress.js into nette.ajax.js
 * For documentation see:
 *  - https://github.com/rstacruz/nprogress
 *  - https://addons.nette.org/vojtech-dobes/nette-ajax-js
 */
(function ($) {
    $.nette.ext('loading', {
        init() {
            NProgress.configure({
                minimum: 0.2,
                template: '<div role="bar"></div><div class="A-backdrop -active -aboveModal peg"></div>'
                    + '<div role="spinner" class="A-spinner -blue -centered">'
                        + '<div class="A-spinner__part"></div>'
                        + '<div class="A-spinner__part"></div>'
                        + '<div class="A-spinner__part"></div>'
                        + '<div class="A-spinner__part"></div>'
                    + '</div>',
            });
        },
        start(xhr, settings) {
            if (!settings.hasOwnProperty('disableSpinner') || settings.disableSpinner !== true) {
                this.pending += 1;
                NProgress.start();
            }
        },
        success(payload, status, jqXHR, settings) {
            if (settings.hasOwnProperty('disableSpinner') && settings.disableSpinner === true) {
                return;
            }
            this.pending -= 1;
            if (this.pending <= 0) {
                this.pending = 0;
                NProgress.done();
                if ($('#offermultistepform-offerpricingform-additionalfacilitymanager-additionalfacility').length) {
                    Bingo.RecalculatePrices.update();
                }
                setTimeout(() => {
                    $('#body-container:not(.backoffice) .datagrid > div:not(.gradient)').dragTable();
                }, 0);
            }
        },
        error(jqXHR, status, error, settings) {
            if (settings.hasOwnProperty('disableSpinner') && settings.disableSpinner === true) {
                return;
            }
            this.pending -= 1;
            if (this.pending <= 0) {
                this.pending = 0;
                NProgress.done();
            }
            // Check type of error, some shouldn't trigger the error message.
            if (status === 'abort') {
                return;
            }
            Bingo.AjaxFailed.showError(Bingo.AjaxFailed.message);
        },
    }, {
        pending: 0,
    });
}(jQuery));
